module.exports = __webpack_public_path__ + "img/pic19.b619b0a9.png";